import { Agentation } from 'agentation'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/i18n'
import App from './App.jsx'
import { ThemeProvider } from './lib/theme.jsx'
import { Toaster } from 'sonner'
import './tenantRefetchRegistry'

// PrimeReact & Quill Styles
//import 'primereact/resources/themes/lara-light-cyan/theme.css';
//import 'primereact/resources/primereact.min.css';
//import 'quill/dist/quill.snow.css';

// Apply saved theme before React renders to avoid light-theme flash in dark mode
(function applyInitialTheme() {
  try {
    const saved = localStorage.getItem('theme')
    const isDark = saved
      ? saved === 'dark'
      : window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    if (isDark) {
      document.documentElement.classList.add('dark')
    }
  } catch {
    // ignore
  }
})()

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => reg.update())
      .catch(() => {})
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <App />
      <Toaster richColors position="bottom-right" />
      {import.meta.env.DEV && <Agentation />}
    </ThemeProvider>
  </StrictMode>
)
